import React, { FC } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { object, number } from 'yup';
import { GoToButton, GoToInput, GoToPageCont, GoToTitle } from './GoToPage.styles';
import { ISurveyFilters } from '../../services/surveys';

interface IGoToPage {
  applyFilters: (filters: ISurveyFilters) => void;
  pageLimit: number | null;
}

const GoToPage: FC<IGoToPage> = ({ applyFilters, pageLimit }) => {
  const limit = pageLimit || 1;
  const goToSchema = object({
    pageNo: number().required().max(limit),
  });
  const { t } = useTranslation();
  const { register, handleSubmit } = useForm({
    defaultValues: {
      pageNo: null,
    },
    resolver: yupResolver(goToSchema),
  });
  return (
    <GoToPageCont onSubmit={handleSubmit(applyFilters)}>
      <GoToTitle>{`${t('surveys.table.pagination.goToPage')}:`}</GoToTitle>
      <GoToInput
        data-testid="GoToPageInput"
        {...register('pageNo')}
        placeholder={t('surveys.table.pagination.no')}
      />
      <GoToButton data-testid="GoToPageButton" type="submit">
        {t('surveys.table.pagination.go')}
      </GoToButton>
    </GoToPageCont>
  );
};

export default GoToPage;
